import React from 'react';

export const ProductSearchContext = React.createContext({});

export const ProductsTableContext = React.createContext({});

export const ProductsComparisonTableContext = React.createContext({});
